import { WidthFull } from "@mui/icons-material";
import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "importControlType",
          label: "Type",
          component: "dropdown",
           options: [
            { label: "Fumigation Control", value: "Fumigation Control" },
            { label: "Preshipment Inspection Control", value: "Preshipment Inspection Control" },
            { label: "Previous Test Report", value: "Previous Test Report" },
            { label: "Probable Inspection Window Request", value: "Probable Inspection Window Request" },
            { label: "Vaccination Control - General", value: "Vaccination Control - General" },
          ],
        },
        {
          name: "importControllocation",
          label: "Location",
          component: "text-field",
        },
      ],
      row2: [
        {
          name: "importControlStartDate",
          label: "Start Date",
          component: "datetimeselector",
          width:"50%"

        },
        {
          name: "importControlEndDate",
          label: "End Date",
          component: "datetimeselector",
          width:"50%"

          
        },
      ],

       row3: [
        {
          name: "importControlResult",
          label: "Result",
          component: "text-field",
          width:"50%",
        },
       
      ],
   
    },
  },
]
};
